module.exports = __webpack_public_path__ + "static/img/guide-24.b28c45d4.png";